var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18146 0C3.22384 0 0 3.22274 0 7.17903C0 11.1353 3.22384 14.3643 7.18146 14.3643C8.87188 14.3643 10.4265 13.7721 11.6553 12.7888L14.6466 15.7776C14.7976 15.9223 14.9992 16.0021 15.2083 16C15.4174 15.9978 15.6174 15.9139 15.7653 15.7662C15.9133 15.6185 15.9975 15.4188 15.9999 15.2097C16.0024 15.0007 15.9228 14.799 15.7783 14.6479L12.787 11.6576C13.7714 10.4274 14.3645 8.87082 14.3645 7.17903C14.3645 3.22274 11.1391 0 7.18146 0ZM7.18146 1.59571C10.2764 1.59571 12.7667 4.08513 12.7667 7.17903C12.7667 10.2729 10.2764 12.7686 7.18146 12.7686C4.08651 12.7686 1.59623 10.2729 1.59623 7.17903C1.59623 4.08513 4.08651 1.59571 7.18146 1.59571Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/monitoring.ea307e0bedadf78a6cfed5473b3ea8d7.svg";
export { ForwardRef as ReactComponent };